"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceType = void 0;
var ServiceType;
(function (ServiceType) {
    ServiceType["ADMIN"] = "admin";
    ServiceType["OFFICE"] = "office";
})(ServiceType || (exports.ServiceType = ServiceType = {}));
//# sourceMappingURL=index.js.map